import { FieldRow as e } from "./FieldRow.es.js";
import { jsx as t } from "react/jsx-runtime";
//#region lib/TVListing/components/Title.tsx
var n = ({ editor: n, element: r, children: i }) => /* @__PURE__ */ t(e, {
	editor: n,
	element: r,
	label: "Titel",
	align: "start",
	children: i
});
//#endregion
export { n as Title };
